module.exports = __webpack_public_path__ + "img/badge_miei_files.3386ac01.jpg";